module.exports = __webpack_public_path__ + "img/bni_syariah.0125810a.svg";